<template>
    <div>
        <template v-if="authenticatedUser" data-unauthenticated>
            <live-channel class="relative" v-if="shouldShowPlayer" />
            <div
                class="pt-20 pb-10 px-2  sm:px-8 bg-contain "
                :style="{
                    backgroundImage: `url('${require('@/assets/img/fondo_play_icons.png')}')`,
                    backgroundColor: '#a000ff'
                }"
                v-else
            >
                <div class="container mx-auto mt-8 mb-5 ">
                    <no-player-banner />
                </div>
            </div>

            <div
                class="pt-10 pb-10 px-2 sm:px-8 bg-contain"
                :style="{
                    backgroundImage: `url('${require('@/assets/img/fondo_play_icons.png')}')`,
                    backgroundColor: '#fe0084'
                }"
            >
                <characters-slider :series="series" :key="`series_bubbles`" />
            </div>

            <episodes-section
                v-for="(category, index) in categories"
                :key="`category_${index}`"
                :title="category.title"
                :background-image="category.background"
                :background-color="category.background_color"
                :episodes="category.episodes"
            >
            </episodes-section>
            <games-section :games="games" v-if="!$isMobile()"></games-section>
        </template>

        <template v-else data-unauthenticated>
            <try-live-channel class="relative" :home-data="homeData">
            </try-live-channel>

            <series-grid-section :series="shuffledSeries">
                <characters-slider :series="series"> </characters-slider>
            </series-grid-section>

            <episodes-section
                v-for="(freeContentItem, index) in freeContent"
                :key="`free_content_item_${index}`"
                :title="$config('FREE_VIDEOS')"
                :background-image="freeContentItem.background"
                :background-color="freeContentItem.background_color"
                :episodes="freeContentItem.episodes"
            >
            </episodes-section>

            <games-section :games="games"></games-section>

            <home-marketing-section></home-marketing-section>

            <episodes-section
                v-for="(category, index) in categories"
                :key="`category_${index}`"
                :title="category.title"
                :background-image="category.background"
                :background-color="category.background_color"
                :episodes="category.episodes"
            >
            </episodes-section>
        </template>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
// import HomeHero from "../components/HomeHero";
import NoPlayerBanner from "@/components/NoPlayerBanner.vue";
import LiveChannel from "../components/LiveChannel";
import TryLiveChannel from "../components/TryLiveChannel";
import CharactersSlider from "../components/CharactersSlider";
import SeriesGridSection from "../components/SeriesGridSection";
import EpisodesSection from "../components/EpisodesSection";
import GamesSection from "../components/GamesSection";
import HomeMarketingSection from "../components/HomeMarketingSection";
import shuffle from "lodash.shuffle";

export default {
    name: "home",

    components: {
        // HomeHero,
        NoPlayerBanner,
        LiveChannel,
        TryLiveChannel,
        CharactersSlider,
        SeriesGridSection,
        EpisodesSection,
        GamesSection,
        HomeMarketingSection
    },
    created() {
        this.$store.dispatch("FETCH_INITIAL_DATA");
    },
    updated() {},
    computed: {
        ...mapState([
            "_ga",
            "series",
            "categories",
            "games",
            "homeData",
            "freeContent",
            "authenticatedUser"
        ]),
        ...mapGetters(["getGa"]),
        shuffledSeries() {
            return shuffle(this.series).slice(0, 6);
        }
    },
    data() {
        return {
            shouldShowPlayer: false
        };
    }
};
</script>

<style scoped>
.head-logged {
    background: url(~@/assets/img/fondo_arboles.jpg) no-repeat bottom center;
    background-size: cover;
    height: 280px;
}
.series_bubbles {
    z-index: 5;
    top: 100px;
}
.series_bubbles_logged {
    position: relative;
    z-index: 5;
    padding-top: 110px;
}
</style>
